export const NEWSLETTERS = [
  {
    pdf: 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/newsletter/Newsletter_Alessa_2019-08-07_carla.pdf',
    date: '30 December 2019',
  },

  {
    pdf: 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/newsletter/Newsletter_Alessa_2019-08-07_carla.pdf',
    date: '31 December 2019',
  },

  {
    pdf: 'https://eidim-media2.s3-us-west-1.amazonaws.com/images/company/newsletter/Newsletter_Alessa_2019-08-07_carla.pdf',
    date: '1 January 2020',
  },


]